function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_35",
  width: 220.196,
  height: 220.196,
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 33
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 23
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ec1d1d",
  floodOpacity: 0.302
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#3c4950}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1302",
  transform: "translate(60.221 36)"
}, /*#__PURE__*/React.createElement("text", {
  id: "New_Order",
  fill: "#3c4950",
  fontFamily: "Arial",
  fontSize: "21px",
  fontWeight: 600,
  transform: "translate(54 108.511)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -53.655,
  y: 0
}, "New Order")), /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  transform: "translate(8.779)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Ellipse_35)",
  transform: "translate(-69 -36)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_35-2",
  fill: "#fff",
  stroke: "#ec1d1d",
  strokeWidth: "2px",
  transform: "translate(69 36)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 41.098,
  cy: 41.098,
  r: 41.098,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.098,
  cy: 41.098,
  r: 40.098,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "noun_Shopping_Cart_3407090",
  transform: "translate(22.414 22.401)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_88"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_40",
  cx: 2.8,
  cy: 2.8,
  r: 2.8,
  className: "cls-3",
  transform: "translate(11.68 32.439)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_41",
  cx: 2.8,
  cy: 2.8,
  r: 2.8,
  className: "cls-3",
  transform: "translate(26.759 32.439)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_630",
  d: "M40.159 8.12a1.5 1.5 0 0 0-1.2-.56H12.52l-.56-3.84a1.546 1.546 0 0 0-1.52-1.32H4.12a1.52 1.52 0 0 0 0 3.04h4.96l4 26.319a1.546 1.546 0 0 0 1.52 1.32H34a1.52 1.52 0 1 0 0-3.04H15.92l-.48-3.2h20.44A1.577 1.577 0 0 0 37.4 25.6l3.12-16.24a1.443 1.443 0 0 0-.361-1.24zm-11.6 10.64h-2.08v2.08a1.52 1.52 0 1 1-3.04 0v-2.08H21.36a1.52 1.52 0 0 1 0-3.04h2.08v-2.08a1.52 1.52 0 1 1 3.04 0v2.08h2.08a1.52 1.52 0 1 1 0 3.04z",
  className: "cls-3",
  transform: "translate(-2.6 -2.4)"
})))));

function SvgNewOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.196,
    height: 220.196,
    viewBox: "0 0 220.196 220.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/newOrder.12716ce9.svg";
export { ForwardRef as ReactComponent };